import React, { useState, useEffect } from "react";
import { Modal, ModalButtonID } from '../ui/components';
import { FailureType } from '../shared/types';
import { parseURI } from '../shared/utils/URI';
import { useSubscribe } from '../hooks';
import { error$ } from '../observables/error';
import { basename } from '../utils/path';
export default function ConfirmDeletion() {
    const [file, setFile] = useState();
    const [name, setName] = useState('');
    useEffect(() => {
        setName(file ? basename(parseURI(file).path) : '');
    }, [file]);
    useSubscribe(() => error$.subscribe(error => {
        if (error.type == FailureType.ConfirmClear) {
            setFile(error.file);
        }
    }));
    const buttons = [
        {
            id: ModalButtonID.Cancel,
            label: 'Cancel'
        },
        {
            id: ModalButtonID.Ok,
            label: 'Clear Contents'
        }
    ];
    const onClose = (id) => {
        if (id == ModalButtonID.Ok) {
            window.f5.clear(file);
        }
        setFile(undefined);
    };
    return React.createElement(React.Fragment, null, file &&
        React.createElement(Modal, { buttons: buttons, onClose: onClose },
            React.createElement("div", { className: 'modal-content', style: { textAlign: 'center' } },
                React.createElement("p", null,
                    React.createElement("strong", null,
                        React.createElement("span", null,
                            "Are you sure you want to clear contents of ",
                            React.createElement("br", null),
                            " '",
                            name,
                            "'?"))),
                React.createElement("p", null,
                    React.createElement("i", null, "This action is irreversible!")))));
}
